<template>
    <!-- 结算  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" :bg2="bg2"
          />
</template>

<script>
import SubPage from "./components/SubPage.vue";
export default {
    name: 'settlement',
    components: {
        SubPage
    },
    data() {
        return {
            // rightBg: "/img/pay/0--35.png",
            bg: "/img/pay/0--36.png",
            bg2: "/img/pay/0--35.png",
        }
    },
    computed: {
        title() {
            return this.$t('settlement.title');
        },
        subtitle() {
            return this.$t('settlement.subtitle');
        },
        description() {
            return [this.$t('settlement.description1'), this.$t('settlement.description2'), this.$t('settlement.description3'), this.$t('settlement.description4')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>